import { Instance, SnapshotOut, types as t } from 'mobx-state-tree';
import { preProcessor, postProcessor } from '../snapshot_processors';
import CommonViews from '../views';
import model from './model';
import actions from '../airthinx/actions';

const AethairProDevice = model.views(CommonViews).actions(actions);

export interface IAethairProDevice extends Instance<typeof AethairProDevice> {}
export interface IAethairProDeviceSnapshot extends SnapshotOut<typeof AethairProDevice> {}

export default t.snapshotProcessor(AethairProDevice, {
  preProcessor,
  postProcessor
});
